import(/* webpackMode: "eager" */ "/app/apps/tagea-web/src/app/[lang]/[tenant]/[institution]/dashboard/dashboard-layout.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/tagea-web/src/app/[lang]/[tenant]/[institution]/dashboard/floating-actions-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InvitationsProvider"] */ "/app/apps/tagea-web/src/libs/features/appointments/application/invitations/invitations.provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/tagea-web/src/libs/features/auth/auth.guard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ChatProvider"] */ "/app/apps/tagea-web/src/libs/features/chat/infrastructure/chat-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FloatingEmergencyForClientsOnly"] */ "/app/apps/tagea-web/src/libs/features/emergency/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UnreadCountsProvider","MainNavigation"] */ "/app/apps/tagea-web/src/libs/features/navigation/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OwnUserProvider"] */ "/app/apps/tagea-web/src/libs/features/users/infrastructure/own-user.provider.tsx");
